<template>
  <div>
    <div>
         <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Dashboard'"
      :titulo="'dashboard'"
    />
      <section class=" text-secondary text-center">
        <div class="py-4">
          <div class="row">
            <div class="col-lg-4">
              <div class="rf_card_profile">
                <div class="card-body text-center">
                  <img
                    src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp"
                    alt="avatar"
                    class="rounded-circle img-fluid"
                    style="width: 150px"
                  />
                  <h5 class="my-3">
                    <strong>{{ currentUser.username }}</strong>
                  </h5>
                  <h5 class="my-3">
                    <strong>{{ currentUser.email }}</strong>
                  </h5>
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="rf_card_profile">
                <div class="card-body g-2 p-4">
                  <div class="row mt-4">
                    <div class="col-6 mt-5">
                      <div class="form-floating">
                        <input
                          type="password"
                          class="form-control rf_bg_form rf_texto"
                          v-model="edit_password"
                        />
                        <label class="rf_texto">Senha</label>
                      </div>
                    </div>
                    <div class="col-6 mt-5">
                      <div class="form-floating">
                        <input
                          type="password"
                          class="form-control rf_bg_form rf_texto"
                          v-model="edit_confirmPassword"
                        />
                        <label class="rf_texto">Confirmar Senha</label>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col">
                      <div class="form-floating">
                        <button
                          type="button"
                          @click="update()"
                          class="btn btn-lg btn-secondary"
                        >
                          Atualizar Senha
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div v-if="abrir_modal">
        <Message :msg="msg" v-show="msg" />
      </div>
      <RodapeVue />
    </div>
  </div>
</template>

<script>
import SidebarVue from "./menu/Sidebar.vue";
import axios from "axios";
import Message from "../components/modal/Message.vue";
import RodapeVue from "./menu/Rodape.vue";

export default {
  name: "Profile",
  components: {
    SidebarVue,
    Message,
    RodapeVue
  },
  data() {
    return {
      //Mensagens do Sistema
      msg: null,
      abrir_modal: false,

      /// Campos Modal Editar
      edit_id: "",
      edit_password: "",
      edit_confirmPassword: ""
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
  methods: {
    async update() {
      if (
        (this.edit_password || this.edit_confirmPassword) &&
        this.edit_password !== this.edit_confirmPassword
      ) {
        this.abrir_modal = true;
        this.msg = "As senhas digitadas não são iguais!";
        setTimeout(() => (this.abrir_modal = false), 4000);
        return;
      }

      const token = this.$store.state.auth.user.accessToken;
      const id_userCad = this.$store.state.auth.user.id;
      const headers = {
        "x-access-token": token
      };
      const dados = {
        id: id_userCad,
        password: this.edit_password,
        id_userCad: id_userCad
      };

      console.log(dados);

      const response = await axios.patch(
        `${process.env.VUE_APP_API_URL}profile/${id_userCad}`,
        dados,
        { headers }
      );
      const resp = JSON.stringify(response.status);
      if (resp == 200) {
        this.edit_password = "";
        this.edit_confirmPassword = "";
        this.abrir_modal = true;
        this.msg = "Alteração realizada com sucesso!";
        setTimeout(() => (this.abrir_modal = false), 4000);
        location.reload();
      }
    }
  }
};
</script>
<style scoped>
/* =========================
   CONTAINER GERAL
========================= */
section {
  min-height: 100vh;
  padding: 40px 20px;
  background: #f4f6f9;
}

/* =========================
   CARDS
========================= */
.rf_card_profile {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.rf_card_profile:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

/* =========================
   AVATAR
========================= */
.rf_card_profile img {
  border: 5px solid #f1f1f1;
  padding: 4px;
  object-fit: cover;
}

/* =========================
   TEXTOS
========================= */
.rf_card_profile h5 {
  color: #2d3436;
  font-weight: 600;
  margin-bottom: 10px;
  word-break: break-word;
}

/* =========================
   FORMULÁRIOS
========================= */
.rf_bg_form {
  background: #f8f9fb !important;
  border: 1px solid #dfe6e9 !important;
  border-radius: 12px !important;
  height: 58px;
  transition: all 0.3s ease;
}

.rf_bg_form:focus {
  border-color: #B92E2E !important;
  box-shadow: 0 0 0 4px rgba(108, 92, 231, 0.15) !important;
  background: #ffffff !important;
}

.rf_texto {
  color: #2d3436 !important;
  font-size: 15px;
}

/* LABEL */
.form-floating label {
  padding-left: 15px;
  color: #636e72;
}

/* =========================
   BOTÃO
========================= */
.btn-secondary {
  background: linear-gradient(135deg, #B92E2E, #c63838);
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 28px;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 100%;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #B92E2E, #B92E2E);
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(90, 79, 207, 0.25);
}

/* =========================
   RESPONSIVO
========================= */
@media (max-width: 991px) {
  .col-lg-4,
  .col-lg-8 {
    margin-bottom: 20px;
  }

  .rf_card_profile {
    border-radius: 14px;
  }

  .btn-secondary {
    width: 100%;
  }
}

@media (max-width: 768px) {
  section {
    padding: 20px 10px;
  }

  .rf_card_profile .card-body {
    padding: 20px !important;
  }

  .rf_card_profile img {
    width: 120px !important;
  }

  .form-floating {
    margin-bottom: 15px;
  }
}
</style>

